import styled from 'styled-components';

import { OnboardingPage } from '@/pages/Onboarding/components/Page';

export const LonelinessGraphStyles = styled(OnboardingPage)<{
  staticTheme: 'dark-violet' | 'domination' | 'purple-gradient' | undefined;
}>`
  body.dark & {
    --lonelones-graph-img-content: url(https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/loneliness/loneliness-graph-dark.png);

    ${({ staticTheme }) =>
      staticTheme === 'dark-violet' &&
      `
      --lonelones-graph-img-content: url(https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/loneliness/loneliness-graph-dark-violet.png);
    `}
  }

  --lonelones-graph-img-content: url(https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/loneliness/loneliness-graph-light.png);

  ion-content {
    .loneliness-graph-title {
      margin: 24px auto 32px;
    }

    .img-container {
      width: 100%;
      max-width: 300px;
      margin: 0 auto 24px;
      aspect-ratio: 0.793;

      @media screen and (min-width: 576px) {
        max-width: 430px;
        margin: 20px auto 0;
      }

      img {
        width: 100%;
        height: 100%;

        content: var(--lonelones-graph-img-content);
      }
    }

    .description {
      margin: 0 auto 0;
      text-align: center;
      padding: 0 16px;
    }
  }
`;
